import { useTable, usePagination, useSortBy } from 'react-table'
import Button from './small/ButtonReal'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'

export default function Table({ columns, data }) {
  const [searchParams, setSearchParams] = useSearchParams({show: 10})
  // const [currentPage, setCurrentPage] = useState(0)
  // const [currentPageSize, setCurrentPageSize] = useState(10)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useSortBy,
    usePagination
  )

  useEffect(() => {
    let currPage = searchParams.get('page')
    let currShow = searchParams.get('show')
    
    setSearchParams({page: (currPage === null || currPage > pageOptions.length || currPage <= 0) ? 1 : currPage, show: (currShow !== null) ? currShow : 10 })

    // setCurrentPageSize(currShow)
    // console.log(currShow)
    // setPageSize(currShow)
    // setPageSize(searchParams.show)

    if(currPage > pageOptions.length || currPage <= 0) {
      currPage = 1
      setSearchParams({ page: 1, show: currShow })
    }

    // setCurrentPage(currPage)
    gotoPage(currPage - 1)
    // setCurrentPage(searchParams.page)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) //searchParams, currentPage, currentPageSize

  return (
    <div className='w-full pt-4 overflow-x-hidden'>{/* fixed overflow-y-auto  justify-center items-center flex*/}
      <div>
      <div className="flex flex-col">
        <div className=" sm:-mx-6 lg:-mx-8 overflow-x-auto">{/* */}
          <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
            <table {...getTableProps()} className="min-w-full">
              <thead className="bg-violet-500 border-b">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps(column.getSortByToggleProps())} className="text-sm font-medium text-white px-6 py-4 text-left">
                        {column.render('Header')}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? ' 🔽'
                              : ' 🔼'
                            : ''}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()} className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100">
                      {row.cells.map(cell => {
                        return <td {...cell.getCellProps()} className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cell.render('Cell')}</td>
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
      </div>
      </div>
      <div className="pagination">
        <Button onClick={() => {
          gotoPage(0)
          setSearchParams({...searchParams, page: 1})
          }} disabled={!canPreviousPage} text={'<<'} />{' '}
        <Button onClick={() => {
          previousPage()
          setSearchParams({...searchParams, page: Number(pageIndex)})
          }} disabled={!canPreviousPage} text={'<'} />{' '}
        <Button onClick={() => {
          nextPage()
          setSearchParams({...searchParams, page: Number(pageIndex) + 2})
        }} disabled={!canNextPage} text={'>'} />{' '}
        <Button onClick={() => {
          gotoPage(pageCount - 1)
          setSearchParams({...searchParams, page: pageCount})
          }} disabled={!canNextPage} text={'>>'} />{' '}
        <span>
          Puslapis{' '}
          <strong>
            {pageIndex + 1} iš {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Eiti į:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
              // setSearchParams({page: Number(e.target.value)})
            }}
            style={{ width: '100px' }}
            className='pt-3 pb-2 inline-block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black border-gray-200'
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
            setSearchParams({page: Number(pageIndex) + 1, show: Number(e.target.value)})
          }}
          className="form-select appearance-none
          inline-block
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding bg-no-repeat
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          m-0
          focus:text-gray-700 focus:bg-white focus:border-violet-700 focus:outline-none"
        >
          {[1, 10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Rodyti {pageSize}
            </option>
          ))}
        </select>
      </div>
      </div>
    </div>
  )
}